import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";

export const getManualEntryListApi = async (payload) => {
    return await api.get(
        `${apiPath.API_URL}${apiPath.ManualEntry.list}`,
        {
            params: payload,
        }
    );
};

export const addManualEntryApi = async (payload) => {
    const response = await api.post(
        `${apiPath.API_URL}${apiPath.ManualEntry.add}`,
        payload
    )
     return response;
};
export const getUpdateManualEntryApi = async (payload) => {

    return await api.get(
        `${apiPath.API_URL}${apiPath.ManualEntry.getUpdate}/${payload.manualCode}`, {
        params: {
            UserCode: payload.UserCode,
        },
    }
    )
}
export const updateManualEntryApi = async (payload) => {
    return await api.put(
        `${apiPath.API_URL}${apiPath.ManualEntry.update}/${payload.manualCode}`,
        {
            UserCode: payload.UserCode,
            ShiftCode: payload.shiftCode,
            AttendanceDate: payload.attendanceDate,
            ClockIn: payload.clockIn,
            ClockOut: payload.clockOut,
            TotalMinutes: payload.totalMinutes,
            TotalHours: payload.totalHours,
            AttendanceStatus: payload.attendanceStatus,
            Reason: payload.reason,
            UpdatedUserCode: payload.updatedUserCode,
            AllowApprovedEdit: payload.allowApprovedEdit,
        }

    )
};
export const getDeleteMessageManualApi = async (payload) => {
    return await api.get(
        `${apiPath.API_URL}${apiPath.ManualEntry.deletemsg}/${payload.manualCode}`, {
        params: {
            UserCode: payload.UserCode,
        },
    }
    );
};

// export async function deleteManualEntryApi (payload) {
//   return await api.delete(
//    `${apiPath.API_URL}${apiPath.ManualEntry.delete}/${payload.manualCode}`, 
//     // {
//     //     params : {
//     //     ShiftGroupCode: payload.ShiftGroupCode,
//     //     }
//     // }
//   );
// }
export const deleteManualEntryApi = async (payload) => {
    return await api.delete(
        `${apiPath.API_URL}${apiPath.ManualEntry.delete}/${payload.manualCode}`,
    //      {
    //     params: {
    //         UserCode: payload.UserCode,
    //     },
    // }
    );

};

export const getShiftTimingApi = async (shiftCode) => {
    return await api.get(
        `${apiPath.API_URL}${apiPath.ManualEntry.ShiftTiming}/${shiftCode}`

    );
};
